import React, { useEffect, useRef, useState } from 'react';
import { IProps } from 'components/Fold/types';

const Fold: React.FC<IProps> = (props) => {
  const foldWrapperRef = useRef<HTMLDivElement>(null);
  const foldRefHeight = useRef<number>(0);
  const [foldHeight, setFoldHeight] = useState<number>(0);

  useEffect(() => {
    foldRefHeight.current = (foldWrapperRef && foldWrapperRef.current) ? foldWrapperRef.current.clientHeight + 1 : 0;
    setFoldHeight(props.isOpen ? foldRefHeight.current : 0);
  }, [props.isOpen, props.planChange]);

  return (
    <div className="fold" style={{ height: foldHeight }}>
      <div className="fold__wrapper" ref={foldWrapperRef}>
        {props.children}
      </div>
    </div>
  );
};

export default Fold;
